import {createContext} from "react"

const SiteContext = createContext({
    site: {},
    addSite: (site) => {},
    toggleMenu: () => {},
    toggleLang: () => {},
    closeLang: () => {},
    toggleSearch: () => {},
    toggleNav: (key) => {},
    submitSearch: (formID) => {},
})

export default  SiteContext